import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'

import * as Sentry from '@sentry/vue'

// socket client
// Нужно для работы laravel echo
// см (src/common/composable/useSockets)
import { io } from 'socket.io-client'
//@ts-ignore
window.io = io

// styles
import 'mosha-vue-toastify/dist/style.css'
import '@/assets/scss/main.scss'

// tailwind
import '@/assets/css/tailwind.css'

// > modern <
import {
    BsIconButton,
    BsAvatar,
    BsField,
    BsLoader,
    BsSearch,
    BsDropdownTooltip,
    BsPageTitle,
    BsPageDescription,
    BsPageHeader,
    BsStatistic,
    BsFiltersContainer,
    BsButton,
    BsSelect,
    BsDateField,
    BsDateCalendar,
    BsPageTableWrapper,
    BsTable,
    BsTableActions,
    BsTableActionsItem,
    BsTableColumnManager,
    BsDivider,
    BsPagination,
    BsHScrollContainer,
    BsModal,
    BsModalScrollContainer,
    BsStatus,
    BsCheckbox,
    BsFileZone,
    BsTextarea
} from '@/modern/components/ui'

const pinia = createPinia()
const app = createApp(App)

app.component('bs-icon-button', BsIconButton)
app.component('bs-avatar', BsAvatar)
app.component('bs-field', BsField)
app.component('bs-loader', BsLoader)
app.component('bs-search', BsSearch)
app.component('bs-dropdown-tooltip', BsDropdownTooltip)
app.component('bs-page-title', BsPageTitle)
app.component('bs-page-description', BsPageDescription)
app.component('bs-page-header', BsPageHeader)
app.component('bs-statistic', BsStatistic)
app.component('bs-filters-container', BsFiltersContainer)
app.component('bs-button', BsButton)
app.component('bs-select', BsSelect)
app.component('bs-date-field', BsDateField)
app.component('bs-date-calendar', BsDateCalendar)
app.component('bs-page-table-wrapper', BsPageTableWrapper)
app.component('bs-table', BsTable)
app.component('bs-table-actions', BsTableActions)
app.component('bs-table-actions-item', BsTableActionsItem)
app.component('bs-table-column-manager', BsTableColumnManager)
app.component('bs-divider', BsDivider)
app.component('bs-pagination', BsPagination)
app.component('bs-h-scroll-container', BsHScrollContainer)
app.component('bs-modal', BsModal)
app.component('bs-modal-scroll-container', BsModalScrollContainer)
app.component('bs-status', BsStatus)
app.component('bs-checkbox', BsCheckbox)
app.component('bs-file-zone', BsFileZone)
app.component('bs-textarea', BsTextarea)

Sentry.init({
    app,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration()
    ],
    tracePropagationTargets: ['localhost', /^https:\/\/gateway\.spark-dev\.team/, /^https:\/\/gateway\.spark\.kz/],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: process.env.VUE_APP_SENTRY_ENV,
    release: '0.1.0'
})

app.use(pinia)
app.use(router)

// хэндлер на ChunkLoadError
router.onError((error) => {
    const chunkFailedMsg = /Loading chunk .* failed/
    if (error.message && chunkFailedMsg.test(error.message)) {
        console.warn('[App] ChunkLoadError, перезагружаю страницу...')
        window.location.reload()
    }
})

app.mount('#app')
